// Thin wrapper around Telegram's official Mini App script (loaded in index.html).
// Outside Telegram, window.Telegram.WebApp exists but initData is empty.
type WebApp = {
  initData: string;
  colorScheme: 'light' | 'dark';
  ready: () => void;
  expand: () => void;
  disableVerticalSwipes?: () => void;
  openInvoice?: (url: string, cb: (status: 'paid' | 'cancelled' | 'failed' | 'pending') => void) => void;
  openLink?: (url: string) => void;
  HapticFeedback?: { notificationOccurred: (kind: 'success' | 'error' | 'warning') => void; selectionChanged: () => void };
  BackButton?: { show: () => void; hide: () => void; onClick: (cb: () => void) => void; offClick: (cb: () => void) => void };
};

const webApp: WebApp | undefined = (window as unknown as { Telegram?: { WebApp?: WebApp } }).Telegram?.WebApp;
const isInside = !!webApp && webApp.initData.length > 0;
let backHandler: (() => void) | null = null;

export const telegram = {
  isInside,
  haptic(kind: 'success' | 'error' | 'selection'): void {
    if (!isInside) return;
    if (kind === 'selection') webApp?.HapticFeedback?.selectionChanged();
    else webApp?.HapticFeedback?.notificationOccurred(kind);
  },
  ready(): void {
    if (!isInside) return;
    webApp!.ready();
    webApp!.expand();
    // Swiping down inside lists should scroll, not close the Mini App.
    webApp!.disableVerticalSwipes?.();
  },
  /** The signed launch data; the server verifies it (never trust it on the client). */
  initData: isInside ? webApp!.initData : '',
  colorScheme: isInside ? webApp!.colorScheme : null,
  /** Opens a Stars invoice inside Telegram; resolves with Telegram's verdict. */
  openInvoice(url: string): Promise<'paid' | 'cancelled' | 'failed' | 'pending'> {
    return new Promise(resolve => (isInside && webApp?.openInvoice ? webApp.openInvoice(url, resolve) : resolve('failed')));
  },
  /** Web pages (legal texts) open in Telegram's browser inside the Mini App, in a new tab elsewhere. */
  openLink(url: string): void {
    if (isInside && webApp?.openLink) webApp.openLink(url);
    else window.open(url, '_blank', 'noopener');
  },
  /** Telegram's own back button mirrors the app's navigation stack. */
  syncBackButton(canGoBack: boolean, goBack: () => void): void {
    const bb = webApp?.BackButton;
    if (!isInside || !bb) return;
    if (backHandler) bb.offClick(backHandler);
    backHandler = goBack;
    bb.onClick(goBack);
    if (canGoBack) bb.show();
    else bb.hide();
  },
};
